/**
 * AdminSettings — admin self-service preferences page.
 *
 * Currently hosts only the OpsAlertPreferencesCard (SCRUM-1798).
 * Future personal-settings cards (e.g., MFA, alternate emails)
 * should be added to this page rather than spreading across
 * separate routes.
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import DashboardLayout from '../../components/layout/DashboardLayout';
import OpsAlertPreferencesCard from '../../components/admin/OpsAlertPreferencesCard';
import OnCallScheduleCard from '../../components/admin/OnCallScheduleCard';

export default function AdminSettings() {
  const navigate = useNavigate();
  const { user: authUser } = useAuth();

  const handleNavigate = (id, path) => {
    if (path) {navigate(path);}
  };

  return (
    <DashboardLayout
      userRole="admin"
      activeNavId="settings"
      onNavigate={handleNavigate}
      user={{
        name: authUser?.fullName || authUser?.firstName || 'Admin',
        email: authUser?.email || '',
        avatar: authUser?.profilePicture || null,
      }}
    >
      <div style={{ marginBottom: 'var(--space-6)' }}>
        <h1 style={{ margin: '0 0 8px', fontSize: '24px', fontWeight: 600 }}>
          Account Settings
        </h1>
        <p style={{ margin: 0, color: '#6b7280', fontSize: '14px' }}>
          Manage your personal preferences for the admin console.
        </p>
      </div>

      <OpsAlertPreferencesCard />
      <OnCallScheduleCard />
    </DashboardLayout>
  );
}
